import React from 'react'


function About(){
    return (
     <>
     <section className="breadcrumb-main pb-15 pt-15 bookingHeaderSection" >
            <div className="section-shape section-shape1 top-inherit bottom-0" ></div>
            <div className="breadcrumb-outer">
                <div className="container">
                    <div className="breadcrumb-content text-center">
                        <h1 className="mb-3">About Us</h1>
                    </div>
                </div>
            </div>
        </section>
        <section className="trending pt-6 pb-0 bg-lgrey">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-xs-12 mb-4">


                        <p>At <strong>The Holiday Experts</strong>, we are dedicated to making your travel dreams a reality. Whether you're looking for flights, hotels, or bespoke travel packages, we strive to provide unmatched value and personalized services tailored to your needs. Our experienced team partners with top airlines, hotels, and travel providers to ensure you enjoy seamless and memorable journeys.</p>
                        <hr />

                        <h3 className="mb-1 theme">Why Choose The Holiday Experts?</h3>
                        
                        
                        <p>1. <strong>Personalized Travel Solutions </strong>– We understand that every traveler is different. That's why we offer tailored travel packages that suit your needs, preferences, and budget.</p>
                        <p>2. <strong>Expert Advice </strong>– With years of experience, our team of travel experts provides you with the best advice, helping you choose the perfect destination, flights, and accommodation.</p>
                        <p>3. <strong>Exclusive Deals & Offers</strong> – Take advantage of our exclusive travel deals and promotions to get the best value for your money.</p>
                        <p>4. <strong>Book Now, Pay Later</strong> – Book now with a small deposit, pay the rest later so you don’t miss out the best option.</p>
                        

                        <hr />

                        <h3 className="mb-1 theme">Our Vision & Mission</h3>

                        <p><strong>Vision:</strong> To be the UK’s leading travel experts, offering unique and personalized holiday experiences that exceed our customers’ expectations.</p>
                        <p><strong>Mission:</strong> To provide exceptional customer service, high-quality travel packages, and expert advice, making us your first choice for all your travel needs. We aim to create memorable and hassle-free holidays for every traveler, whether they're seeking for flights, hotels or holidays packages for adventure, relaxation, or a cultural journey.</p>
                        <hr />

                         
                        <h3 className="mb-1 theme">Contact Us</h3>
                        <p>Ready to book your next holiday? Contact us today, and our team of experts will be happy to assist you!</p>
                        <p><strong>Phone:</strong> [Insert Phone Number]</p>
                        <p><strong>Email:</strong> [Insert Email Address]</p>
                        <p><strong>Office Hours:</strong> Monday – Friday, 9 AM – 6 PM Saturday, 9 AM – 3 PM</p>

                    </div>
                </div>
            </div>
        </section>            
     </>
    )
}
export default About;    